import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

// prettier-ignore
export const wantedPersonsGridColumns = [
  { label: 'Osoba', field: 'person.name', displayField: 'person', mapper: parent => get(parent, 'fullName'), type: ColumnType.TEXT, width: 80 },
  { label: 'Adresa', field: 'address', displayField: 'person', mapper: parent => get(parent, 'address.fullAddress'), type: ColumnType.TEXT, width: 80 },
  { label: 'Datum narození', field: 'birthDate', displayField: 'person', mapper: parent => get(parent, 'birthDate'), type: ColumnType.DATE, width: 200 },
  { label: 'Rodné číslo', field: 'birthNumber', displayField: 'person', mapper: parent => get(parent, 'birthNumber'), type: ColumnType.TEXT, width: 80 },
  { label: 'Hlášeno', field: 'reportedDate', type: ColumnType.DATE, width: 200 },
  { label: 'Poznámka', field: 'note', type: ColumnType.TEXT, width: 80 },
  { label: 'Důvod pátrání', field: 'reason', displayField: 'reason', mapper: parent => get(parent, 'name'), type: ColumnType.TEXT, width: 80 },
  { label: 'Nalezen', field: 'found', type: ColumnType.BOOLEAN, width: 80 }
];



// WEBPACK FOOTER //
// ./src/modules/wantedPersons/_wantedPersonsColumns.ts